export default "__VITE_ASSET__B6WrJTW6__"